import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import EmployeeOverview from './EmployeeOverview';
import EmployeeListings from './EmployeeListings';
import EmployeeEnquiries from './EmployeeEnquiries';
import EmployeeVisits from './EmployeeVisits';
import EmployeeAddListing from './EmployeeAddListing';
import Profile from '../Profile';

const LINKS = [
  { to: '/employee', end:true, label: 'Overview',   testid: 'emp-overview' },
  { to: '/employee/listings', label: 'My listings', testid: 'emp-listings' },
  { to: '/employee/add',      label: 'Add listing', testid: 'emp-add' },
  { to: '/employee/enquiries',label: 'Enquiries',   testid: 'emp-enquiries' },
  { to: '/employee/visits',   label: 'Field visits',testid: 'emp-visits' },
  { to: '/employee/profile',  label: 'Profile',     testid: 'emp-profile' },
];

export default function EmployeeLayout() {
  return (
    <div className="ap-shell" data-testid="employee-shell">
      <Sidebar title="Employee" links={LINKS} />
      <main className="ap-content">
        <Routes>
          <Route index element={<EmployeeOverview />} />
          <Route path="listings" element={<EmployeeListings />} />
          <Route path="add" element={<EmployeeAddListing />} />
          <Route path="enquiries" element={<EmployeeEnquiries />} />
          <Route path="visits" element={<EmployeeVisits />} />
          <Route path="profile" element={<Profile />} />
          <Route path="*" element={<Navigate to="/employee" replace />} />
        </Routes>
      </main>
    </div>
  );
}
